<div class="row">
    <div class="col-md-12">
        <h5>Upcoming test</h5>
        <br />
        <!-- web delivery -->
        <div *ngIf="upcomingRegistration.isWebDelivery">
            <hr />
            <app-web-delivery
                [isUpcomingTest]="true"
                [reg]="upcomingRegistration"
            ></app-web-delivery>
        </div>
        <!-- non web delivery -->
        <div
            class="panel"
            *ngIf="!upcomingRegistration.isWebDelivery"
        >
            <div class="row">
                <div class="col-12 col-sm-3">
                    <h5>Test Type:</h5>
                </div>
                <div class="col-12 col-sm-9">
                    <div>{{ upcomingRegistration.testTypeName }}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-3">
                    <h5>Registration Number:</h5>
                </div>
                <div class="col-12 col-sm-9">
                    {{ upcomingRegistration.publicRegIdentifier }}
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-3">
                    <h5>Test Date & Time:</h5>
                </div>
                <div class="col-12 col-sm-9">
                    <div>
                        {{upcomingRegistration.testDateTime | customDate: 'formatDateTime'}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-3">
                    <h5>Test Location:</h5>
                </div>
                <div class="col-12 col-sm-9">
                    {{upcomingRegistration.testCentreName}}<br />
                    <p class="white-space-pre">{{upcomingRegistration.testCentreLocation}}</p>
                    <p>
                        You must arrive 45 MINUTES prior to your
                        {{ upcomingRegistration.testTypeName }} Test. Check-in for
                        your test closes 15 MINUTES before the scheduled start time.
                        If you arrive after this time, you will be denied entrance
                        to the {{ upcomingRegistration.testTypeName }} Test and will
                        not be eligible for a refund or transfer.
                    </p>
                    <div *ngIf="upcomingRegistration.testTypeId !== saftTypeId">
                        <ul>
                            <li *ngIf="(brandId === BrandEnum.CELPIP &&  upcomingRegistration.isInCancelledTestSession !== true) ||  upcomingRegistration.brandTestTypeId === caelCETestTypeId">
                                <a
                                    class="info-url"
                                    (click)="resendEmail(upcomingRegistration)"
                                >Resend Test Confirmation Email</a>
                            </li>
                            <li>
                                <a
                                    href="{{testDayInfoUrl}}"
                                    target="_blank"
                                >
                                    Test Day Procedures
                                </a>
                            </li>
                            <li><a
                                    href="{{regPoliciesUrl}}"
                                    target="_blank"
                                >
                                    Cancellation, Transfer, and Retake Policies
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-3">
                </div>
                <div class="col-12 col-sm-9">
                    <div *ngIf="launchSRDownload && brandId === BrandEnum.CELPIP &&  !upcomingRegistration.isInCancelledTestSession">
                        Your CELPIP Official Score Report will be available for download as a PDF once your scores have been posted.
                    </div>
                    <div *ngIf="upcomingRegistration.isInCancelledTestSession">
                        <strong class="cancelled-test">Your {{BrandEnum[brandId]}} Test has been cancelled. Please contact Paragon to transfer your test to another date.</strong>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-3">
                </div>

                <div class="col-12 col-sm-9">
                    <app-test-actions
                        [reg]="upcomingRegistration"
                        [isUpcomingTest]="true"
                    ></app-test-actions>
                </div>
            </div>
            <div
                *ngIf="registrationManualApprovalRequired"
                class="row"
            >
                <div class="col-12">
                    <strong>Pending Approval</strong>
                </div>
            </div>
            <br />
            <div
                *ngIf="!upcomingRegistration.biometricConsent"
                class="alert alert-danger"
                role="alert"
            >
                Please update <a
                    [routerLink]="['/account/biometric-consent']"
                    class="alert-link"
                >biometric consent</a> before your test date
            </div>
        </div>
    </div>
</div>
